import {Injectable} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthType, EMAIL_REGEX} from '../../common/constants';

@Injectable()
export class RegisterPageValidator {

  formError = {
    name: '',
    email: '',
    password: '',
    password_confirmation: ''
  };
  constructor(private fb: FormBuilder) {}

  createForm(type) {
    if (type === AuthType.register) {
      return this.fb.group({
        'name': ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(255)])],
        'email': [
          '', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX), Validators.maxLength(64)])
        ],
        'password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        'password_confirmation': ['', Validators.compose([Validators.required, this.passwordConfirming])],
        'group_id': ['']
      });
    }
    if (type === AuthType.reset_password) {
      return this.fb.group({
        'token': [''],
        'email': [
          '', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEX), Validators.maxLength(64)])
        ],
        'password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
        'password_confirmation': ['', Validators.compose([Validators.required, this.passwordConfirming])],
      });
    }
  }

  private passwordConfirming(c: AbstractControl): { invalid: boolean } {
    if (c.value && c.root.get('password').value !== c.value) {
      return {invalid: true};
    } else {
      return null;
    }
  }

  validateRegisterForm(form: FormGroup) {
    if (!form) {
      return;
    }
    const errorMsg = this.getValidationMessages();
    for (const field in this.formError) {
      this.formError[field] = '';
      const control = form.get(field);
      if (control && control.invalid) {
        const messages = errorMsg[field];
        for (const key in control.errors) {
          if (messages.hasOwnProperty(key)) {
            this.formError[field] = errorMsg[field][key];
          }
        }
      }
    }

  }

  getValidationMessages() {
    return {
      'name': {
        'required': 'Fullname field is required.',
        'minlength': 'Fullname must be at least 4 characters in length.',
        'maxlength': 'Fullname must be less than 255 characters in length.'
      },
      'email': {
        'required': 'The email field is required.',
        'pattern': 'Email is invalid.'
      },
      'password': {
        'required': 'The password field is required.',
        'minlength': 'Passwords must be at least 6 characters long.'
      },
      'password_confirmation': {
        'required': 'The confirm password field is required.',
        'invalid': 'The confirm password and password must match.'
      }
    };
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/login-page/register-page.validator.ts